export default "__VITE_ASSET__DdFAUGOH__"